import { render } from "./AddAboutus.vue?vue&type=template&id=f74d0358&scoped=true"
import script from "./AddAboutus.vue?vue&type=script&lang=js"
export * from "./AddAboutus.vue?vue&type=script&lang=js"

import "./AddAboutus.vue?vue&type=style&index=0&id=f74d0358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f74d0358"]])

export default __exports__